import React from 'react';
import {Card} from "../global/Card";
import {Button} from "../global/Button";

import discoverImg from '../../images/use.svg';
import rifLogo from '../../images/build/rif_white_120px.svg';

export const Discover = (props) => {

  const data = props.data || {};
  const data2 = props.data2 || {};

  const rifData = data2.items;

  const renderRifData = () => {
    return rifData.map((card, index) => (
      <Card
        key={index}
        label={`0${index + 1}`}
        title={card.title}
        color="yellow"
        text={card.text}
      />
    ))
  }

  return (
    <section className="py-16">
      <div className="container">
        <span className="zg-label bg-green me-2">{data.number}</span>
        <span className="zg-label bg-green">{data.suptitle}</span>
        <div className="row">
          <div className="col-lg-7 col-md-12">
            <h2 className="h3 mb-8 mt-6 letter-spacing-4">{data.title}</h2>
          </div>
        </div>
        <div className="row mb-lg-18 mb-16">
          <div className="col-lg-3 offset-lg-2 col-md-6">
            <img
              className="mb-6 mb-md-0"
              src={discoverImg}
              alt="discover"
              width="396"
              height="360"
              loading="lazy"
            />
          </div>
          <div className="col-lg-4 col-md-6 offset-lg-1">
            <p className="subtitle-md mb-6">{data.text}</p>
            <Card
              title={data.cardTitle}
              color="cyan"
              text={data.cardText}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <span className="zg-label bg-green me-2">{data2.number}</span>
            <span className="zg-label bg-green">{data2.suptitle}</span>
          </div>
        </div>
        <div className="row mb-9">
          <div className="col-lg-6 col-md-6">
            <h2 className="h3 mb-6 mb-md-8 mt-6 letter-spacing-4">{data2.title}</h2>
            <img className="mb-md-0 mb-6" src={rifLogo} alt="RIF Logo"/>
          </div>
          <div className="col-lg-3 col-md-6 ">
            <p className="zg-text-sm mt-md-6 mb-6">{data2.text}</p>
            <Button
              title="Discover RIF products"
              url="https://www.rifos.org/"
              external={true}
            />
          </div>
        </div>
        <div className="rif-grid">
          {renderRifData()}
        </div>
      </div>
    </section>
  )
}
